export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";